import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import CentralLink from './CentralLink.js';

import loadable from '@loadable/component';
const StaticNonStaticMapBaseLoadable = loadable(() => import('./StaticNonStaticMapBaseLoadable.js'));


function FMCoverageArea({ lat, lng, locationBlurb, locationName, locationSubdomain }) {
	
	let ownerShipLocationName = locationName;
	if(locationName[locationName.length-1] === 's') {
		ownerShipLocationName += "'";
	} else {
		ownerShipLocationName += "'s";
	}
	
	/*
	const StaticMap = ({ children, lat, lng, noDefaultMarker, zoom = 13, label, style, geoJSON, additionalCustomGeoJSON }) => {
    return <StaticNonStaticMapBaseLoadable
        lat={lat}
        lng={lng}
        noDefaultMarker={noDefaultMarker}
        zoom={zoom}
        label={label}
        style={style}
        geoJSON={geoJSON}
        additionalCustomGeoJSON={additionalCustomGeoJSON}
    >{children}</StaticNonStaticMapBaseLoadable>
};
*/

	let linkPath = "/";
	if(typeof window !== 'undefined' && window.cordova) {
		linkPath = "/floodnav/" + locationSubdomain;
		locationSubdomain = "www";
	}

	return [
		<Col xs={12} md={6} lg={3} xl={2} xxl={2} className="mx-auto d-lg-none" key={"small_" + locationName}>
			<Card style={{ width: '100%' }}>
		      <CentralLink to={linkPath} subdomain={locationSubdomain}>
			      <div className="card-img-top">
			      	<StaticNonStaticMapBaseLoadable
			      			lat={lat}
			      			lng={lng}
			      			zoom={13}
			      			style={{ height: '20vh', width: '100%' }}
			      	/>
			      </div>
			  </CentralLink>
		      <Card.Body>
		        <Card.Title>{locationName}</Card.Title>
		        {locationBlurb && <Card.Text>{locationBlurb}</Card.Text>}
		        <CentralLink to={linkPath} subdomain={locationSubdomain}>
		        	<Button variant="dark">View {ownerShipLocationName} FloodNav</Button>
		        </CentralLink>
		      </Card.Body>
		    </Card>
		</Col>,
		<Col lg={6} className="mx-auto d-none d-lg-block" style={{marginBottom: "6px", marginTop: "6px", marginRight: "2px", marginLeft: "2px"}}  key={"lg_" + locationName}>
			<Card style={{ width: '100%' }}>
				<Card.Header as="h4" className="bg-dark text-white">{locationName}</Card.Header>
				<Card.Body style={{padding: '0 0 0 0'}}>
					<Row>
						<Col lg={3}>
							<CentralLink to={linkPath} subdomain={locationSubdomain}>
								<div className="card-img-top">
									<StaticNonStaticMapBaseLoadable
										lat={lat}
										lng={lng}
										zoom={13}
										zoomControl={false}
										scrollWheelZoom={false}
										dragging={false}
										touchZoom={false}
										style={{ height: '20vh', width: '100%' }}
									/>
								</div>
							</CentralLink>
						</Col>
						<Col lg={9} className="d-flex align-items-center justify-content-center">
							<span>
								{locationBlurb && <Card.Text>{locationBlurb}</Card.Text>}
								<CentralLink to={linkPath} subdomain={locationSubdomain}>
						        	<Button variant="dark">View {ownerShipLocationName} FloodNav</Button>
						        </CentralLink>
					       	</span>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</Col>
	];
}


export default FMCoverageArea;